import React from 'react';

export const StyleguideRoute = () => (
  <iframe
    src="/styleguide.html"
    title="Spinnaker styleguide"
    style={{ border: 0, height: 'calc(100vh - 60px)', width: '100%' }}
  />
);
